import React, {Fragment, useState} from 'react';
import {FaArrowAltCircleRight, FaArrowAltCircleLeft} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Image_slider = ({slides}) => {
    const [current, setCurrent] = useState(0);
    const length = slides.length;

    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    }
    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    }

    //use useeffect to put an arrow click into dependency and timeout resets everytime it is clicked
    // setTimeout(nextSlide, 7000);

    if(!Array.isArray(slides) || slides.length <= 0) {
        return null;
    }

    return (
        <Fragment>
            <section className="slider flex items-center justify-center" id="slider_cover">
                <FaArrowAltCircleLeft className="left-arrow text-gray-900" onClick={prevSlide}/>
                <FaArrowAltCircleRight className="right-arrow text-gray-900" onClick={nextSlide}/>
                {slides.map((slide, index) => {
                    return(
                        <Link to={slide.link}>
                            <div className={index === current ? 'slide active' : 'slide'} key={index}>
                                {index === current && (<img src={slide.image} alt="images" className="image" style={{height: `${slide.height}`, width: `${slide.width}`}}/>)}
                            </div>
                        </Link>
                    )
                })}
            </section>
        </Fragment>
    )
};

export default Image_slider
